import {generateInitialState} from "@/helpers/generateInitialState";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {syncInitialState} from "../initialStates";

const initialState = await generateInitialState("sync", syncInitialState);

const syncSlice = createSlice({
  name: "sync",
  initialState,
  reducers: {
    startSync: (state, action) => {
      state.isSynchronising = true;
      state.data = {...action.payload};
    },
    updateSyncStatus: (state, action) => {
      const newState = {...state.data, ...action.payload};
      state.data = newState;
    },
    syncDone: (state, action) => {
      state.isSynchronising = false;
      state.data = {};
    },
    toggleLoadingScreen: (state, action) => {
      const {show, msg = ""} = action.payload;
      if (show !== true && show !== false) return;

      state.showLoadingScreen = show;
      state.loadingScreenMsg = msg;
    },
  },
  extraReducers: builder => {},
  selectors: {
    syncStateSelector: state => state,
  },
});

export const {startSync, syncDone, toggleLoadingScreen, updateSyncStatus} = syncSlice.actions;
export const {syncStateSelector} = syncSlice.selectors;
export default syncSlice.reducer;
